import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import SearchField from "./SearchField";

// ----------------------------------------------------------------------

interface AdminFilterBarProps {
  search: string;
  onSearch: (value: string) => void;
  placeholder?: string;
  /** Slot para selects de filtro (Status, Categoria, etc.) */
  filters?: ReactNode;
  /** Rótulo de contagem (ex.: "8 itens", "3 de 8 itens"). Use countLabel() para gerar. */
  count: string;
}

/** Barra de busca + filtros + contagem para telas de CRUD do admin. */
export default function AdminFilterBar({ search, onSearch, placeholder, filters, count }: AdminFilterBarProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2, flexWrap: "wrap" }}>
      <Box sx={{ flex: 1, maxWidth: 380 }}>
        <SearchField value={search} onChange={onSearch} placeholder={placeholder} />
      </Box>

      {filters}

      <Typography
        sx={{
          ml: "auto",
          fontSize: "13px",
          color: "text.secondary",
          whiteSpace: "nowrap",
        }}
      >
        {count}
      </Typography>
    </Box>
  );
}
